module.exports = __webpack_public_path__ + "static/img/行驶.84d2e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/越野车/行驶.png
// module id = tuD2
// module chunks = 76